module.exports = __webpack_public_path__ + "img/bot-right-bg.cd97d6f1.png";